import produce from 'immer';
import React, { useEffect, useState } from 'react';
import { asyncSimpleModal } from '../../../../lib/common';
import WidgetForm from '../WidgetForm';
import WidgetHomeMenu from '../WidgetHomeMenu';

const WidgetHomeMenuWrap = ({ homeMenu, onSubmit }) => {
  const [selectedMenuItemId, setSelectedMenuItemId] = useState(null);
  // 실시간으로 변경되는 홈메뉴 리스트
  const [editingHomeMenu, setEditingHomeMenu] = useState(homeMenu);
  const [isDirty, setIsDirty] = useState(false);

  useEffect(() => {
    setEditingHomeMenu(homeMenu);
  }, [homeMenu]);

  const onClickMenuItem = async (itemId) => {
    if (isDirty) {
      const confirmResult = await asyncSimpleModal({
        type: 'confirm',
        title: '메뉴 편집',
        message: (
          <>
            해당 메뉴 편집을 중단하시겠습니까?
            <br />
            확인 버튼을 누를 시, 현재 편집하던 내용은 사라지게 됩니다.
          </>
        ),
      });

      if (!confirmResult) return;

      restoreHomeMenu();
      setSelectedMenuItemId(itemId);
    } else {
      setSelectedMenuItemId(itemId);
    }
  };

  const onSubmitClick = (data) => {
    setIsDirty(false);
    onSubmit(data);
  };

  const onCancel = () => {
    restoreHomeMenu();
  };

  const restoreHomeMenu = () => {
    setIsDirty(false);
    setEditingHomeMenu(homeMenu);
  };

  /**
   * 메뉴 편집 실시간 반영
   * 업데이트 request시에는 {..., imgList[]}형태로 보내지만 get시에는 {..., url:""} 이런 형태로 오기때문에 실시간 반영을 위해서 이미지 변경 발생시 url필드를 함께 업데이트한다
   */
  const onChangeMenuItem = (changedFields) => {
    setIsDirty(true);

    const updatedHomeMenu = produce(editingHomeMenu, (draft) => {
      const index = draft.findIndex((item) => item.id === selectedMenuItemId);
      if (index !== -1) {
        for (const key in changedFields) {
          draft[index][key] = changedFields[key].value;
          if (key === 'imgList') {
            draft[index]['url'] = changedFields[key].value.length > 0 ? changedFields[key].value[0].url : '';
            draft[index]['path'] = changedFields[key].value.length > 0 ? changedFields[key].value[0].path : '';
          }
        }
      }
    });

    setEditingHomeMenu(updatedHomeMenu);
  };

  return (
    <div className="widget-home-menu-wrap">
      <WidgetHomeMenu
        homeMenu={editingHomeMenu}
        selectedMenuItemId={selectedMenuItemId}
        onClickMenuItem={onClickMenuItem}
      />

      {selectedMenuItemId && (
        <WidgetForm
          menuItem={editingHomeMenu.find((item) => item.id === selectedMenuItemId)}
          onChangeMenuItem={onChangeMenuItem}
          onSubmit={onSubmitClick}
          onCancel={onCancel}
        />
      )}
    </div>
  );
};

export default WidgetHomeMenuWrap;
